<template>
  <div class="content">
    <div class="page-title flex align-center just-content-between">
      <div class="flex">
        <p>{{ pageTitle }}</p>
        <p class="u-ml30">{{ tabs + 1 }} / {{ tabsMax + 1 }}</p>
      </div>
      <div class="flex align-center u-ml40 u-mr20" style="font-size: 14px">
        <span class="icon">
          <font-awesome-icon icon="user" size="2x"></font-awesome-icon>
        </span>
        <p class="u-mr10 u-ml5 u-mb0">{{ schoolYear }}</p>
        <p class="u-mb0">{{ childName }}</p>
      </div>
    </div>
    <OrganismsAnchorLink
      :anchorLinks="useDefine.defineObject.NAV_BASIC_SURVEY_3_ANCHORS_ARRAY"
      @goToPageAnchor="goToPage"
    />

    <p class="prohibited-text">
      ※ブラウザの戻るボタン/再読み込みは使用しないでください。<br />入力中のデータが正しく処理されません。
    </p>
    <div class="form-wrap">
      <div class="tab -0" v-if="tabs === 0">
        <section class="form-section u-mb20">
          <div class="contents-wrap u-mt0">
            <atoms-sub-label index="3-1" label="記入者情報" />
            <atoms-input-text
              class="u-mb30"
              label="記入者"
              type="text"
              placeholder="記入者"
              inputmode="text"
              :required="false"
              v-model="formData.writer"
              setKey="writer"
              @input-emit="handleUpdateValue"
            ></atoms-input-text>
          </div>

          <atoms-label label="動作" />

          <div class="contents-wrap u-mt0">
            <atoms-sub-label index="3-2" label="床上" />

            <atoms-input-select
              label="寝返り"
              v-model="formData.motionTheFloorRollingOver"
              setKey="motionTheFloorRollingOver"
              :options="useDefine.defineObject.ROLLINGOVER_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-select
              label="起き上がり"
              v-model="formData.motionTheFloorGetUp"
              setKey="motionTheFloorGetUp"
              :options="useDefine.defineObject.GETUP_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-select
              label="座位保持"
              v-model="formData.motionTheFloorSittingPositionHeld"
              setKey="motionTheFloorSittingPositionHeld"
              :options="useDefine.defineObject.SITTINGPOSITIONHELD_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-select
              label="立位保持"
              v-model="formData.motionTheFloorStandingHolding"
              setKey="motionTheFloorStandingHolding"
              :options="useDefine.defineObject.STANDINGHOLDING_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-select
              label="移乗"
              v-model="formData.motionTheFloorTransfer"
              setKey="motionTheFloorTransfer"
              :options="useDefine.defineObject.TRANSFER_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-textarea
              label="場所・補助具・介護状況など"
              placeholder="場所・補助具・介護状況など"
              :required="false"
              v-model="formData.motionTheFloorPlaceAuxiliaryEquipmentSituation"
              setKey="motionTheFloorPlaceAuxiliaryEquipmentSituation"
              @input-emit="handleUpdateValue"
            ></atoms-input-textarea>

            <atoms-input-radio
              label="エアーマットの使用"
              v-model="formData.motionTheFloorElectricBed"
              setKey="motionTheFloorElectricBed"
              :options="useDefine.defineObject.ELECTRICBED_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
            ></atoms-input-radio>

            <atoms-input-radio
              label="電動ベッド"
              v-model="formData.motionTheFloorUseOfAirMat"
              setKey="motionTheFloorUseOfAirMat"
              :options="useDefine.defineObject.USEOFAIRMAT_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
            ></atoms-input-radio>
          </div>
        </section>
      </div>

      <div class="tab -1" v-if="tabs === 1">
        <section class="form-section u-mb20">
          <div class="contents-wrap u-mt0">
            <atoms-sub-label index="3-3" label="移動" />
            <atoms-input-select
              label="屋内"
              v-model="formData.motionMovementIndoor"
              setKey="motionMovementIndoor"
              :options="useDefine.defineObject.INDOOR_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-select
              label="屋外"
              v-model="formData.motionMovementOutdoors"
              setKey="motionMovementOutdoors"
              :options="useDefine.defineObject.OUTDOORS_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-textarea
              label="補装具の使用（杖 短下肢装具 歩行器 車椅子 その他）"
              placeholder="補装具の使用（杖 短下肢装具 歩行器 車椅子 その他）"
              :required="false"
              v-model="formData.motionMovementUseOfProsthetics"
              setKey="motionMovementUseOfProsthetics"
              @input-emit="handleUpdateValue"
            ></atoms-input-textarea>
          </div>

          <div class="contents-wrap">
            <atoms-sub-label index="3-4" label="入浴" />

            <atoms-input-select
              label="浴槽出入り"
              v-model="formData.motionBathingTubAndOut"
              setKey="motionBathingTubAndOut"
              :options="useDefine.defineObject.TUBANDOUT_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-select
              label="洗身"
              v-model="formData.motionBathingWashing"
              setKey="motionBathingWashing"
              :options="useDefine.defineObject.WASHING_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-select
              label="洗髪"
              v-model="formData.motionBathingShampoo"
              setKey="motionBathingShampoo"
              :options="useDefine.defineObject.SHAMPOO_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-textarea
              label="留意点（頻度等）"
              placeholder="留意点（頻度等）"
              :required="false"
              v-model="formData.motionBathingConsiderations"
              setKey="motionBathingConsiderations"
              @input-emit="handleUpdateValue"
            ></atoms-input-textarea>

            <atoms-input-select
              label="方法"
              v-model="formData.motionBathingMethod"
              setKey="motionBathingMethod"
              :options="useDefine.defineObject.METHOD_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <div class="input-wrap-group u-mt0">
              <atoms-input-text
                label="現在の身長"
                type="text"
                inputmode="numeric"
                placeholder="100"
                :required="false"
                v-model="formData.motionBathingHeight"
                setKey="motionBathingHeight"
                widthClassName="w-smallest"
                @input-emit="handleUpdateValue"
              ></atoms-input-text>
              <span>cm</span>
            </div>

            <div class="input-wrap-group u-mt0">
              <atoms-input-text
                label="現在の体重"
                type="text"
                inputmode="numeric"
                placeholder="30"
                :required="false"
                v-model="formData.motionBathingWeight"
                setKey="motionBathingWeight"
                widthClassName="w-smallest"
                @input-emit="handleUpdateValue"
              ></atoms-input-text>
              <span>kg</span>
            </div>
          </div>
        </section>
      </div>

      <div class="tab -2" v-if="tabs === 2">
        <section class="form-section u-mb20">
          <div class="contents-wrap u-mt0">
            <atoms-sub-label index="3-5" label="排泄" />

            <atoms-input-select
              label="排尿"
              v-model="formData.motionExcretionUrination"
              setKey="motionExcretionUrination"
              :options="useDefine.defineObject.URINATION_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-text
              label="回数"
              type="text"
              inputmode="numeric"
              placeholder="5"
              :required="false"
              v-model="formData.motionExcretionUrinationViews"
              setKey="motionExcretionUrinationViews"
              widthClassName="w-smallest"
              @input-emit="handleUpdateValue"
            ></atoms-input-text>

            <atoms-input-select
              label="尿意"
              v-model="formData.motionExcretionUrinationUrinate"
              setKey="motionExcretionUrinationUrinate"
              :options="useDefine.defineObject.URINATE_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-radio
              label="尿意の伝達"
              v-model="formData.motionExcretionUrinationTransmission"
              setKey="motionExcretionUrinationTransmission"
              :options="useDefine.defineObject.TRANSMISSION_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
            ></atoms-input-radio>

            <atoms-input-select
              label="排便"
              v-model="formData.motionExcretionDefecation"
              setKey="motionExcretionDefecation"
              :options="useDefine.defineObject.DEFECATION_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-text
              label="回数"
              type="text"
              inputmode="numeric"
              placeholder="1"
              :required="false"
              v-model="formData.motionExcretionDefecationViews"
              setKey="motionExcretionDefecationViews"
              widthClassName="w-smallest"
              @input-emit="handleUpdateValue"
            ></atoms-input-text>

            <atoms-input-select
              label="便意"
              v-model="formData.motionExcretionDefecationBowelMovement"
              setKey="motionExcretionDefecationBowelMovement"
              :options="useDefine.defineObject.BOWELMOVEMENT_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-radio
              label="便意の伝達"
              v-model="formData.motionExcretionDefecationTransmission"
              setKey="motionExcretionDefecationTransmission"
              :options="useDefine.defineObject.TRANSMISSION_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
            ></atoms-input-radio>

            <atoms-input-select
              label="失禁"
              v-model="formData.motionExcretionDefecationIncontinence"
              setKey="motionExcretionDefecationIncontinence"
              :options="useDefine.defineObject.INCOUNTINENCE_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-select
              label="便通"
              v-model="formData.motionExcretionDefecationBowelMove"
              setKey="motionExcretionDefecationBowelMove"
              :options="useDefine.defineObject.BOWELMOVE_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-select
              label="間接支援"
              v-model="formData.motionExcretionIndirectSupport"
              setKey="motionExcretionIndirectSupport"
              :options="useDefine.defineObject.INDIRECTSUPPORT_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-select
              label="方法"
              v-model="formData.motionExcretionMethod"
              setKey="motionExcretionMethod"
              :options="useDefine.defineObject.EXCRETIONMETHOD_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>
          </div>
        </section>
      </div>

      <div class="tab -3" v-if="tabs === 3">
        <section class="form-section u-mb20">
          <div class="contents-wrap u-mt0">
            <atoms-sub-label index="3-6" label="食事" />
            <atoms-input-select
              label="食事摂取"
              v-model="formData.motionMealDietaryIntake"
              setKey="motionMealDietaryIntake"
              :options="useDefine.defineObject.DIETARYINTAKE_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-select
              label="飲水"
              v-model="formData.motionMealDrinkingWater"
              setKey="motionMealDrinkingWater"
              :options="useDefine.defineObject.DRINKINGWATER_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-select
              label="嚥下"
              v-model="formData.motionMealSwallowing"
              setKey="motionMealSwallowing"
              :options="useDefine.defineObject.SWALLOWING_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-select
              label="食事形態"
              v-model="formData.motionMealMealForm"
              setKey="motionMealMealForm"
              :options="useDefine.defineObject.MEALFORM_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-radio
              label="自助具の使用"
              v-model="formData.motionMealUseOfSelfHelpTool"
              setKey="motionMealUseOfSelfHelpTool"
              :options="useDefine.defineObject.USEOFSELFHELPTOOL_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
            ></atoms-input-radio>

            <atoms-input-select
              label="自助具の使用有"
              v-model="formData.motionMealUseOrganicSelfHelpTool"
              setKey="motionMealUseOrganicSelfHelpTool"
              :options="
                useDefine.defineObject.USEORGANICSELFHELPTOOL_OPTION_ARRAY
              "
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-textarea
              label="栄養状態"
              placeholder="栄養状態"
              :required="false"
              v-model="formData.motionMealNutritionalStatus"
              setKey="motionMealNutritionalStatus"
              @input-emit="handleUpdateValue"
            ></atoms-input-textarea>

            <atoms-input-select
              label="食事内容"
              v-model="formData.motionMealDiet"
              setKey="motionMealDiet"
              :options="useDefine.defineObject.DIET_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-textarea
              label="特別食"
              placeholder="特別食"
              :required="false"
              v-model="formData.motionMealSpecialDietMenus"
              setKey="motionMealSpecialDietMenus"
              @input-emit="handleUpdateValue"
            ></atoms-input-textarea>

            <atoms-input-text
              label="食事回数"
              type="text"
              inputmode="numeric"
              placeholder="3"
              :required="false"
              v-model="formData.motionMealMealTimes"
              setKey="motionMealMealTimes"
              widthClassName="w-smallest"
              @input-emit="handleUpdateValue"
            ></atoms-input-text>

            <atoms-input-text
              label="食欲"
              type="text"
              inputmode="text"
              placeholder="食欲あり"
              :required="false"
              v-model="formData.motionMealAppetite"
              setKey="motionMealAppetite"
              @input-emit="handleUpdateValue"
            ></atoms-input-text>
          </div>
        </section>
      </div>

      <div class="tab -4" v-if="tabs === 4">
        <section class="form-section u-mb20">
          <div class="contents-wrap u-mt0">
            <atoms-sub-label index="3-7" label="清潔" />
            <atoms-input-select
              label="口腔清潔"
              v-model="formData.motionCleanlinessOralCleanliness"
              setKey="motionCleanlinessOralCleanliness"
              :options="useDefine.defineObject.CLEANLINESS_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-select
              label="洗顔"
              v-model="formData.motionCleanlinessCleansing"
              setKey="motionCleanlinessCleansing"
              :options="useDefine.defineObject.CLEANLINESS_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-select
              label="整髪"
              v-model="formData.motionCleanlinessHairdressing"
              setKey="motionCleanlinessHairdressing"
              :options="useDefine.defineObject.CLEANLINESS_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-select
              label="爪切り"
              v-model="formData.motionCleanlinessNailClippers"
              setKey="motionCleanlinessNailClippers"
              :options="useDefine.defineObject.CLEANLINESS_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>
          </div>

          <div class="contents-wrap">
            <atoms-sub-label index="3-8" label="着脱" />

            <atoms-input-select
              label="上着"
              v-model="formData.motionRemovableJacket"
              setKey="motionRemovableJacket"
              :options="useDefine.defineObject.REMOVABLE_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-select
              label="ズボン等"
              v-model="formData.motionRemovableTrousers"
              setKey="motionRemovableTrousers"
              :options="useDefine.defineObject.REMOVABLE_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>
          </div>

          <div class="contents-wrap">
            <atoms-sub-label index="3-9" label="I-ADL" />
            <atoms-input-select
              label="洗濯"
              v-model="formData.motionIAdlWashing"
              setKey="motionIAdlWashing"
              :options="useDefine.defineObject.IADL_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-select
              label="掃除"
              v-model="formData.motionIAdlCleanUp"
              setKey="motionIAdlCleanUp"
              :options="useDefine.defineObject.IADL_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-select
              label="整理・整頓"
              v-model="formData.motionIAdlOrganizeAndTidy"
              setKey="motionIAdlOrganizeAndTidy"
              :options="useDefine.defineObject.IADL_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-select
              label="買物"
              v-model="formData.motionIAdlShopping"
              setKey="motionIAdlShopping"
              :options="useDefine.defineObject.IADL_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-select
              label="調理"
              v-model="formData.motionIAdlCooking"
              setKey="motionIAdlCooking"
              :options="useDefine.defineObject.IADL_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-select
              label="金銭管理"
              v-model="formData.motionIAdlMoneyManagement"
              setKey="motionIAdlMoneyManagement"
              :options="useDefine.defineObject.IADL_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-select
              label="電話の利用"
              v-model="formData.motionIAdlUseOfTelephone"
              setKey="motionIAdlUseOfTelephone"
              :options="useDefine.defineObject.IADL_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>
          </div>
        </section>
      </div>

      <div class="tab -5" v-if="tabs === 5">
        <section class="form-section u-mb20">
          <atoms-label label="コミュニケーションスキル" />
          <div class="contents-wrap u-mt0">
            <atoms-sub-label index="3-10" label="視力" />

            <atoms-input-select
              label="視力"
              v-model="formData.motionCommunicationSkillsEyesight"
              setKey="motionCommunicationSkillsEyesight"
              :options="useDefine.defineObject.EYESIGHT_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-check-box
              label="視覚障害"
              v-model="formData.motionCommunicationSkillsVisuallyImpaired"
              setKey="motionCommunicationSkillsVisuallyImpaired"
              :options="useDefine.defineObject.DISABILITY_RIGHT_AND_LEFT"
              @input-emit="handleUpdateValue"
              :is-tap="true"
              class="w-100"
            ></atoms-input-check-box>

            <atoms-input-radio
              label="白杖の利用"
              v-model="formData.motionCommunicationSkillsUseOfWhiteCane"
              setKey="motionCommunicationSkillsUseOfWhiteCane"
              :options="useDefine.defineObject.PRESENCEORABSENCE_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
            ></atoms-input-radio>
          </div>

          <div class="contents-wrap">
            <atoms-sub-label index="3-11" label="聴力" />

            <atoms-input-select
              label="聴力"
              v-model="formData.motionCommunicationSkillsHearing"
              setKey="motionCommunicationSkillsHearing"
              :options="useDefine.defineObject.HEARING_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-check-box
              label="聴覚障害"
              v-model="formData.motionCommunicationSkillsHearingImpairment"
              setKey="motionCommunicationSkillsHearingImpairment"
              :options="useDefine.defineObject.DISABILITY_RIGHT_AND_LEFT"
              @input-emit="handleUpdateValue"
              :is-tap="true"
              class="w-100"
            ></atoms-input-check-box>

            <atoms-input-radio
              label="補聴器"
              v-model="formData.motionCommunicationSkillsHearingAid"
              setKey="motionCommunicationSkillsHearingAid"
              :options="useDefine.defineObject.PRESENCEORABSENCE_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
            ></atoms-input-radio>

            <atoms-input-radio
              label="手話"
              v-model="formData.motionCommunicationSkillsSignLanguage"
              setKey="motionCommunicationSkillsSignLanguage"
              :options="useDefine.defineObject.PROPRIETY_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
            ></atoms-input-radio>
          </div>

          <div class="contents-wrap">
            <atoms-sub-label index="3-12" label="意思の伝達" />

            <atoms-input-select
              label="意思の伝達"
              v-model="
                formData.motionCommunicationSkillsTransmissionOfIntention
              "
              setKey="motionCommunicationSkillsTransmissionOfIntention"
              :options="
                useDefine.defineObject.TRANSMISSIONOFINTENTION_OPTION_ARRAY
              "
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-radio
              label="言語障害"
              v-model="formData.motionCommunicationSkillsLanguageDisorders"
              setKey="motionCommunicationSkillsLanguageDisorders"
              :options="useDefine.defineObject.PRESENCEORABSENCE_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
            ></atoms-input-radio>
          </div>

          <div class="contents-wrap">
            <atoms-sub-label index="3-13" label="コミュニケーション" />
            <atoms-input-textarea
              label="コミュニケーション機器"
              placeholder="コミュニケーション機器"
              :required="false"
              v-model="formData.motionCommunicationSkillsCommunicationEquipment"
              setKey="motionCommunicationSkillsCommunicationEquipment"
              @input-emit="handleUpdateValue"
            ></atoms-input-textarea>

            <atoms-input-select
              label="理解度"
              v-model="formData.motionCommunicationSkillsLevelOfUnderstanding"
              setKey="motionCommunicationSkillsLevelOfUnderstanding"
              :options="
                useDefine.defineObject.LEVELOFUNDERSTANDING_OPTION_ARRAY
              "
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-select
              label="話す"
              v-model="formData.motionCommunicationSkillsSpeak"
              setKey="motionCommunicationSkillsSpeak"
              :options="useDefine.defineObject.SPEAK_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-select
              label="書く"
              v-model="formData.motionCommunicationSkillsWrite"
              setKey="motionCommunicationSkillsWrite"
              :options="useDefine.defineObject.WRITE_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-select
              label="読む"
              v-model="formData.motionCommunicationSkillsRead"
              setKey="motionCommunicationSkillsRead"
              :options="useDefine.defineObject.READ_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-radio
              label="認知症症状"
              v-model="formData.motionCommunicationSkillsDementiaSymptoms"
              setKey="motionCommunicationSkillsDementiaSymptoms"
              :options="useDefine.defineObject.PRESENCEORABSENCE_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
            ></atoms-input-radio>

            <atoms-input-radio
              label="精神症状"
              v-model="formData.motionCommunicationSkillsPsychiatricSymptoms"
              setKey="motionCommunicationSkillsPsychiatricSymptoms"
              :options="useDefine.defineObject.PRESENCEORABSENCE_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
            ></atoms-input-radio>

            <atoms-input-radio
              label="知的障害"
              v-model="formData.motionCommunicationSkillsIntellectualDisability"
              setKey="motionCommunicationSkillsIntellectualDisability"
              :options="useDefine.defineObject.PRESENCEORABSENCE_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
            ></atoms-input-radio>

            <atoms-input-radio
              label="要配慮行動"
              v-model="formData.motionBehaviorRequiringConsideration"
              setKey="motionBehaviorRequiringConsideration"
              :options="useDefine.defineObject.PRESENCEORABSENCE_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
            ></atoms-input-radio>

            <atoms-input-textarea
              label="none"
              placeholder="要配慮行動について"
              :required="false"
              v-model="
                formData.motionBehaviorRequiringConsiderationHaveIntellectualDisability
              "
              setKey="motionBehaviorRequiringConsiderationHaveIntellectualDisability"
              @input-emit="handleUpdateValue"
            ></atoms-input-textarea>
          </div>
        </section>
      </div>

      <div class="tab -6" v-if="tabs === 6">
        <section class="form-section u-mb20">
          <atoms-label label="身辺処理" />
          <div class="contents-wrap u-mt0">
            <atoms-sub-label index="3-14" label="生活" />

            <atoms-input-select
              label="食事"
              v-model="formData.affairsProcessingMeal"
              setKey="affairsProcessingMeal"
              :options="useDefine.defineObject.AFFAIRSPROCESSING_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-select
              label="排泄"
              v-model="formData.affairsProcessingExcretion"
              setKey="affairsProcessingExcretion"
              :options="useDefine.defineObject.AFFAIRSPROCESSING_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-select
              label="衣服着脱"
              v-model="formData.affairsProcessingClothesDetachable"
              setKey="affairsProcessingClothesDetachable"
              :options="useDefine.defineObject.AFFAIRSPROCESSING_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-select
              label="入浴"
              v-model="formData.affairsProcessingBathing"
              setKey="affairsProcessingBathing"
              :options="useDefine.defineObject.AFFAIRSPROCESSING_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-select
              label="身だしなみ"
              v-model="formData.affairsProcessingGrooming"
              setKey="affairsProcessingGrooming"
              :options="useDefine.defineObject.AFFAIRSPROCESSING_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-select
              label="生理の始末"
              v-model="formData.affairsProcessingSettlementOfPhysiological"
              setKey="affairsProcessingSettlementOfPhysiological"
              :options="useDefine.defineObject.AFFAIRSPROCESSING_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-select
              label="服薬・健康管理"
              v-model="formData.affairsProcessingMedicationHealthManagement"
              setKey="affairsProcessingMedicationHealthManagement"
              :options="useDefine.defineObject.AFFAIRSPROCESSING_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-textarea
              label="具体的な様子"
              placeholder="具体的な様子"
              :required="false"
              v-model="formData.affairsProcessingSpecificSituation"
              setKey="affairsProcessingSpecificSituation"
              @input-emit="handleUpdateValue"
            ></atoms-input-textarea>

            <atoms-input-textarea
              label="その他支援が必要な状況"
              placeholder="その他支援が必要な状況"
              :required="false"
              v-model="formData.affairsProcessingOtherAssistance"
              setKey="affairsProcessingOtherAssistance"
              @input-emit="handleUpdateValue"
            ></atoms-input-textarea>
          </div>
        </section>
      </div>

      <div class="tab -7" v-if="tabs === 7">
        <section class="form-section u-mb20">
          <div class="contents-wrap u-mt0">
            <atoms-sub-label index="3-15" label="意思表示・伝達" />
            <atoms-input-select
              label="意思表示の手段・程度"
              v-model="formData.communicationManifestationOfIntention"
              setKey="communicationManifestationOfIntention"
              :options="
                useDefine.defineObject.MANIFESTATIONOFINTENTION_OPTION_ARRAY
              "
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-select
              label="他者からの意思伝達の理解"
              v-model="formData.communicationUnderstandingOfCommunication"
              setKey="communicationUnderstandingOfCommunication"
              :options="
                useDefine.defineObject.UNDERSTANDINGOFCOMMUNICATION_OPTION_ARRAY
              "
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-textarea
              label="具体的な様子"
              placeholder="具体的な様子"
              :required="false"
              v-model="formData.communicationSpecificSituation"
              setKey="communicationSpecificSituation"
              @input-emit="handleUpdateValue"
            ></atoms-input-textarea>

            <atoms-input-textarea
              label="その他支援が必要な状況"
              placeholder="その他支援が必要な状況"
              :required="false"
              v-model="formData.communicationOtherAssistance"
              setKey="communicationOtherAssistance"
              @input-emit="handleUpdateValue"
            ></atoms-input-textarea>
          </div>

          <div class="contents-wrap">
            <atoms-sub-label index="3-16" label="日常生活" />
            <atoms-input-select
              label="洗濯"
              v-model="formData.everydayLifeWashing"
              setKey="everydayLifeWashing"
              :options="useDefine.defineObject.EVERYDAYLIFE_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-select
              label="掃除"
              v-model="formData.everydayLifeCleanUp"
              setKey="everydayLifeCleanUp"
              :options="useDefine.defineObject.EVERYDAYLIFE_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-select
              label="整理・整頓"
              v-model="formData.everydayLifeOrganizeAndTidy"
              setKey="everydayLifeOrganizeAndTidy"
              :options="useDefine.defineObject.EVERYDAYLIFE_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-select
              label="買物"
              v-model="formData.everydayLifeShopping"
              setKey="everydayLifeShopping"
              :options="useDefine.defineObject.EVERYDAYLIFE_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-select
              label="調理"
              v-model="formData.everydayLifeCooking"
              setKey="everydayLifeCooking"
              :options="useDefine.defineObject.EVERYDAYLIFE_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-textarea
              label="具体的な様子"
              placeholder="具体的な様子"
              :required="false"
              v-model="formData.everydayLifeSpecificSituation"
              setKey="everydayLifeSpecificSituation"
              @input-emit="handleUpdateValue"
            ></atoms-input-textarea>
          </div>
        </section>
      </div>

      <div class="tab -8" v-if="tabs === 8">
        <section class="form-section u-mb20">
          <div class="contents-wrap u-mt0">
            <atoms-sub-label index="3-17" label="社会生活" />
            <atoms-input-select
              label="屋外移動"
              v-model="formData.socialLifeOutdoorMovement"
              setKey="socialLifeOutdoorMovement"
              :options="useDefine.defineObject.OUTDOORMOVEMENT_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-select
              label="対人関係"
              v-model="formData.socialLifeInterpersonalRelations"
              setKey="socialLifeInterpersonalRelations"
              :options="
                useDefine.defineObject
                  .INTERPERSONALRELATIONSANDMONEYMANAGEMENT_OPTION_ARRAY
              "
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-select
              label="金銭管理"
              v-model="formData.socialLifeMoneyManagement"
              setKey="socialLifeMoneyManagement"
              :options="
                useDefine.defineObject
                  .INTERPERSONALRELATIONSANDMONEYMANAGEMENT_OPTION_ARRAY
              "
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-select
              label="文字"
              v-model="formData.socialLifeLetter"
              setKey="socialLifeLetter"
              :options="useDefine.defineObject.LETTER_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-select
              label="集団"
              v-model="formData.socialLifeGroup"
              setKey="socialLifeGroup"
              :options="useDefine.defineObject.GROUP_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-select
              label="時間"
              v-model="formData.socialLifeTime"
              setKey="socialLifeTime"
              :options="useDefine.defineObject.TIME_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-textarea
              label="具体的な様子"
              placeholder="具体的な様子"
              :required="false"
              v-model="formData.socialLifeSpecificSituation"
              setKey="socialLifeSpecificSituation"
              @input-emit="handleUpdateValue"
            ></atoms-input-textarea>
          </div>

          <p>
            記入にあたって以下を基準にし、当てはまる記号を選択してください
          </p>
          <div class=" u-mt5 bold flex">
            <p class="u-mr10">◎:ほぼ毎日あり</p>
            <p class="u-mr10">○:週1、2回程度あり</p>
            <p class="u-mr10">△:週1回未満</p>
            <p>×:なし</p>
          </div>

          <div class="contents-wrap">
            <atoms-sub-label index="3-18" label="要配慮行動" />

            <atoms-input-radio-block
              label="強いこだわり"
              v-model="formData.socialLifeConsiderationBehaviorStrongCommitment"
              setKey="socialLifeConsiderationBehaviorStrongCommitment"
              :options="useDefine.defineObject.SYMBOLSELECTION_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
              class="w-100"
            ></atoms-input-radio-block>

            <atoms-input-radio-block
              label="多動"
              v-model="formData.socialLifeConsiderationBehaviorHyperactivity"
              setKey="socialLifeConsiderationBehaviorHyperactivity"
              :options="useDefine.defineObject.SYMBOLSELECTION_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
              class="w-100"
            ></atoms-input-radio-block>

            <atoms-input-radio-block
              label="パニック"
              v-model="formData.socialLifeConsiderationBehaviorPanic"
              setKey="socialLifeConsiderationBehaviorPanic"
              :options="useDefine.defineObject.SYMBOLSELECTION_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
              class="w-100"
            ></atoms-input-radio-block>

            <atoms-input-radio-block
              label="睡眠障害"
              v-model="formData.socialLifeConsiderationBehaviorSleepingDisorder"
              setKey="socialLifeConsiderationBehaviorSleepingDisorder"
              :options="useDefine.defineObject.SYMBOLSELECTION_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
              class="w-100"
            ></atoms-input-radio-block>

            <atoms-input-radio-block
              label="食事・排泄に係る不適応行動"
              v-model="
                formData.socialLifeConsiderationBehaviorMaladaptativeBehavior
              "
              setKey="socialLifeConsiderationBehaviorMaladaptativeBehavior"
              :options="useDefine.defineObject.SYMBOLSELECTION_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
              class="w-100"
            ></atoms-input-radio-block>

            <atoms-input-radio-block
              label="自傷他害"
              v-model="
                formData.socialLifeConsiderationBehaviorSelfHarmOtherHarm
              "
              setKey="socialLifeConsiderationBehaviorSelfHarmOtherHarm"
              :options="useDefine.defineObject.SYMBOLSELECTION_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
              class="w-100"
            ></atoms-input-radio-block>

            <atoms-input-textarea
              label="具体的な様子"
              placeholder="具体的な様子"
              :required="false"
              v-model="
                formData.socialLifeConsiderationBehaviorSpecificSituation
              "
              setKey="socialLifeConsiderationBehaviorSpecificSituation"
              @input-emit="handleUpdateValue"
              class="w-100"
            ></atoms-input-textarea>
          </div>
        </section>
      </div>

      <div class="tab -9" v-if="tabs === 9">
        <section class="form-section u-mb20">
          <atoms-label label="自立生活能力" />

          <p>記入にあたって以下を基準にし、当てはまる番号を選択してください</p>
          <div class=" u-mt5 bold flex">
            <p class="u-mr10">1:自立</p>
            <p class="u-mr10">2:見守り</p>
            <p class="u-mr10">3:一部介助</p>
            <p>4:全介助</p>
          </div>
          <div class="contents-wrap u-mt0">
            <atoms-sub-label index="3-19" label="身の回りのこと" />
            <atoms-input-radio-block
              label="（1）個人衛生"
              v-model="formData.livingAbilityPersonalBelongingsPersonalHygiene"
              setKey="livingAbilityPersonalBelongingsPersonalHygiene"
              :options="useDefine.defineObject.NUMBERSELECTION_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
              class="w-100"
            ></atoms-input-radio-block>

            <atoms-input-radio-block
              label="（2）自室の整頓"
              v-model="formData.livingAbilityPersonalBelongingsRoomArrangement"
              setKey="livingAbilityPersonalBelongingsRoomArrangement"
              :options="useDefine.defineObject.NUMBERSELECTION_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
              class="w-100"
            ></atoms-input-radio-block>

            <atoms-input-radio-block
              label="（3）金銭管理"
              v-model="formData.livingAbilityPersonalBelongingsMoneyManagement"
              setKey="livingAbilityPersonalBelongingsMoneyManagement"
              :options="useDefine.defineObject.NUMBERSELECTION_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
              class="w-100"
            ></atoms-input-radio-block>

            <atoms-input-radio-block
              label="（4）洗濯"
              v-model="formData.livingAbilityPersonalBelongingsWashing"
              setKey="livingAbilityPersonalBelongingsWashing"
              :options="useDefine.defineObject.NUMBERSELECTION_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
              class="w-100"
            ></atoms-input-radio-block>

            <atoms-input-radio-block
              label="（5）買い物"
              v-model="formData.livingAbilityPersonalBelongingsShopping"
              setKey="livingAbilityPersonalBelongingsShopping"
              :options="useDefine.defineObject.NUMBERSELECTION_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
              class="w-100"
            ></atoms-input-radio-block>

            <atoms-input-radio-block
              label="（6）食事をとる"
              v-model="formData.livingAbilityPersonalBelongingsMeals"
              setKey="livingAbilityPersonalBelongingsMeals"
              :options="useDefine.defineObject.NUMBERSELECTION_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
              class="w-100"
            ></atoms-input-radio-block>

            <atoms-input-radio-block
              label="（7）食事をつくる"
              v-model="formData.livingAbilityPersonalBelongingsMakeMeal"
              setKey="livingAbilityPersonalBelongingsMakeMeal"
              :options="useDefine.defineObject.NUMBERSELECTION_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
              class="w-100"
            ></atoms-input-radio-block>

            <atoms-input-textarea
              label="具体的な様子"
              placeholder="具体的な様子"
              :required="false"
              v-model="
                formData.livingAbilityPersonalBelongingsSpecificSituation
              "
              setKey="livingAbilityPersonalBelongingsSpecificSituation"
              @input-emit="handleUpdateValue"
            ></atoms-input-textarea>
          </div>

          <div class="contents-wrap">
            <atoms-sub-label index="3-20" label="安全管理" />
            <atoms-input-radio-block
              label="（1）危険な行為かどうかの判断ができる"
              v-model="formData.livingAbilitySafetyManagementCrisisManagement"
              setKey="livingAbilitySafetyManagementCrisisManagement"
              :options="useDefine.defineObject.NUMBERSELECTION_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
              class="w-100"
            ></atoms-input-radio-block>

            <atoms-input-radio-block
              label="（2）火の始末ができる"
              v-model="formData.livingAbilitySafetyManagementDisposeOfFire"
              setKey="livingAbilitySafetyManagementDisposeOfFire"
              :options="useDefine.defineObject.NUMBERSELECTION_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
              class="w-100"
            ></atoms-input-radio-block>

            <atoms-input-textarea
              label="具体的な様子"
              placeholder="具体的な様子"
              :required="false"
              v-model="formData.livingAbilitySafetyManagementSpecificSituation"
              setKey="livingAbilitySafetyManagementSpecificSituation"
              @input-emit="handleUpdateValue"
              :is-tap="true"
            ></atoms-input-textarea>
          </div>
        </section>
      </div>

      <div class="tab -10" v-if="tabs === 10">
        <section class="form-section u-mb20">
          <p>記入にあたって以下を基準にし、当てはまる番号を選択してください</p>
          <div class=" u-mt5 bold flex">
            <p class="u-mr10">1:自立</p>
            <p class="u-mr10">2:見守り</p>
            <p class="u-mr10">3:一部介助</p>
            <p>4:全介助</p>
          </div>

          <div class="contents-wrap u-mt0">
            <atoms-sub-label index="3-21" label="健康管理" />
            <atoms-input-radio-block
              label="（1）定期的な通院ができる"
              v-model="formData.livingAbilityHealthManagementRegularVisits"
              setKey="livingAbilityHealthManagementRegularVisits"
              :options="useDefine.defineObject.NUMBERSELECTION_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
              class="w-100"
            ></atoms-input-radio-block>

            <atoms-input-radio-block
              label="（2）服薬管理ができる"
              v-model="
                formData.livingAbilityHealthManagementMedicationManagement
              "
              setKey="livingAbilityHealthManagementMedicationManagement"
              :options="useDefine.defineObject.NUMBERSELECTION_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
              class="w-100"
            ></atoms-input-radio-block>

            <atoms-input-radio-block
              label="（3）身体健康の管理"
              v-model="
                formData.livingAbilityHealthManagementPhysicalHealthManagement
              "
              setKey="livingAbilityHealthManagementPhysicalHealthManagement"
              :options="useDefine.defineObject.NUMBERSELECTION_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
              class="w-100"
            ></atoms-input-radio-block>

            <atoms-input-textarea
              label="具体的な様子"
              placeholder="具体的な様子"
              :required="false"
              v-model="formData.livingAbilityHealthManagementSpecificSituation"
              setKey="livingAbilityHealthManagementSpecificSituation"
              @input-emit="handleUpdateValue"
              :is-tap="true"
            ></atoms-input-textarea>
          </div>

          <div class="contents-wrap">
            <atoms-sub-label index="3-22" label="社会資源の活用" />
            <atoms-input-radio-block
              label="（1）交通機関の利用ができる"
              v-model="formData.livingAbilitySocialResourcesUseOfTransportation"
              setKey="livingAbilitySocialResourcesUseOfTransportation"
              :options="useDefine.defineObject.NUMBERSELECTION_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
              class="w-100"
            ></atoms-input-radio-block>

            <atoms-input-radio-block
              label="（2）金融機関の利用ができる"
              v-model="
                formData.livingAbilitySocialResourcesUseOfFinancialInstitutions
              "
              setKey="livingAbilitySocialResourcesUseOfFinancialInstitutions"
              :options="useDefine.defineObject.NUMBERSELECTION_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
              class="w-100"
            ></atoms-input-radio-block>

            <atoms-input-radio-block
              label="（3）電話の利用ができる"
              v-model="formData.livingAbilitySocialResourcesUseOfTelephone"
              setKey="livingAbilitySocialResourcesUseOfTelephone"
              :options="useDefine.defineObject.NUMBERSELECTION_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
              class="w-100"
            ></atoms-input-radio-block>

            <atoms-input-textarea
              label="具体的な様子"
              placeholder="具体的な様子"
              :required="false"
              v-model="formData.livingAbilitySocialResourcesSpecificSituation"
              setKey="livingAbilitySocialResourcesSpecificSituation"
              @input-emit="handleUpdateValue"
            ></atoms-input-textarea>
          </div>

          <div class="contents-wrap">
            <atoms-sub-label index="3-23" label="対人関係" />
            <atoms-input-radio-block
              label="（1）あいさつなど最低限のつきあいができる"
              v-model="
                formData.livingAbilityInterpersonalRelationsMinimalRelationship
              "
              setKey="livingAbilityInterpersonalRelationsMinimalRelationship"
              :options="useDefine.defineObject.NUMBERSELECTION_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
              class="w-100"
            ></atoms-input-radio-block>

            <atoms-input-radio-block
              label="（2）協調性"
              v-model="formData.livingAbilityInterpersonalRelationsCooperation"
              setKey="livingAbilityInterpersonalRelationsCooperation"
              :options="useDefine.defineObject.NUMBERSELECTION_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
              class="w-100"
            ></atoms-input-radio-block>

            <atoms-input-radio-block
              label="（3）自発性"
              v-model="formData.livingAbilityInterpersonalRelationsSpontaneous"
              setKey="livingAbilityInterpersonalRelationsSpontaneous"
              :options="useDefine.defineObject.NUMBERSELECTION_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
              class="w-100"
            ></atoms-input-radio-block>

            <atoms-input-radio-block
              label="（4）友人等との付き合い"
              v-model="
                formData.livingAbilityInterpersonalRelationsHangingOutWithFriends
              "
              setKey="livingAbilityInterpersonalRelationsHangingOutWithFriends"
              :options="useDefine.defineObject.NUMBERSELECTION_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
              class="w-100"
            ></atoms-input-radio-block>

            <atoms-input-textarea
              label="具体的な様子"
              placeholder="具体的な様子"
              :required="false"
              v-model="
                formData.livingAbilityInterpersonalRelationsSpecificSituation
              "
              setKey="livingAbilityInterpersonalRelationsSpecificSituation"
              @input-emit="handleUpdateValue"
            ></atoms-input-textarea>
          </div>

          <div class="contents-wrap">
            <atoms-sub-label index="3-24" label="社会的役割・時間の活用" />
            <atoms-input-radio-block
              label="（1）自分なりの社会的役割を持つ"
              v-model="
                formData.livingAbilitySocialRoleUtilizationOfTimeOwnSocialRole
              "
              setKey="livingAbilitySocialRoleUtilizationOfTimeOwnSocialRole"
              :options="useDefine.defineObject.NUMBERSELECTION_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
              class="w-100"
            ></atoms-input-radio-block>

            <atoms-input-radio-block
              label="（2）自由時間のすごし方"
              v-model="
                formData.livingAbilitySocialRoleUtilizationOfTimeFreeTime
              "
              setKey="livingAbilitySocialRoleUtilizationOfTimeFreeTime"
              :options="useDefine.defineObject.NUMBERSELECTION_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
              class="w-100"
            ></atoms-input-radio-block>

            <atoms-input-radio-block
              label="（3）生活リズム"
              v-model="
                formData.livingAbilitySocialRoleUtilizationOfTimeLifeRhythm
              "
              setKey="livingAbilitySocialRoleUtilizationOfTimeLifeRhythm"
              :options="useDefine.defineObject.NUMBERSELECTION_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
              class="w-100"
            ></atoms-input-radio-block>

            <atoms-input-textarea
              label="具体的な様子"
              placeholder="具体的な様子"
              :required="false"
              v-model="
                formData.livingAbilitySocialRoleUtilizationOfTimeSpecificSituation
              "
              setKey="livingAbilitySocialRoleUtilizationOfTimeSpecificSituation"
              @input-emit="handleUpdateValue"
            ></atoms-input-textarea>
          </div>
        </section>
      </div>

      <div class="tab -11" v-if="tabs === 11">
        <section class="form-section u-mb20">
          <atoms-label label="緊急時の対応" />

          <p>記入にあたって以下を基準にし、当てはまる番号を選択してください</p>
          <div class=" u-mt5 bold flex">
            <p class="u-mr10">1:自立</p>
            <p class="u-mr10">2:見守り</p>
            <p class="u-mr10">3:一部介助</p>
            <p>4:全介助</p>
          </div>

          <div class="contents-wrap u-mt0">
            <atoms-sub-label index="3-25" label="対応" />

            <atoms-input-radio-block
              label="（1）心配事（ストレスをうけた）の相談ができる"
              v-model="formData.emergencyResponseConsultationOfConcerns"
              setKey="emergencyResponseConsultationOfConcerns"
              :options="useDefine.defineObject.NUMBERSELECTION_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
              class="w-100"
            ></atoms-input-radio-block>

            <atoms-input-radio-block
              label="（2）悪化時の対処"
              v-model="formData.emergencyResponseDeal"
              setKey="emergencyResponseDeal"
              :options="useDefine.defineObject.NUMBERSELECTION_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
              class="w-100"
            ></atoms-input-radio-block>

            <atoms-input-textarea
              label="具体的な様子"
              placeholder="具体的な様子"
              :required="false"
              v-model="formData.emergencyResponseSpecificSituation"
              setKey="emergencyResponseSpecificSituation"
              @input-emit="handleUpdateValue"
            ></atoms-input-textarea>
          </div>

          <div class="contents-wrap">
            <atoms-label label="配慮が必要な社会行動" />
            <p>
              記入にあたって以下を基準にし、当てはまる番号を選択してください
            </p>
            <div class=" u-mt5 bold flex">
              <p class="u-mr10">1:自立</p>
              <p class="u-mr10">2:見守り</p>
              <p class="u-mr10">3:一部介助</p>
              <p>4:全介助</p>
            </div>
            <div class="contents-wrap u-mt0">
              <atoms-sub-label index="3-26" label="社会行動" />
              <atoms-input-radio-block
                label="（1）公共の場でのマナーに配慮できる"
                v-model="
                  formData.behaviorsThatRequireConsiderationMannersInPublic
                "
                setKey="behaviorsThatRequireConsiderationMannersInPublic"
                :options="useDefine.defineObject.NUMBERSELECTION_OPTION_ARRAY"
                @input-emit="handleUpdateValue"
                :is-tap="true"
                class="w-100"
              ></atoms-input-radio-block>

              <atoms-input-radio-block
                label="（2）自殺ないし自傷の念慮や行為がない"
                v-model="
                  formData.behaviorsThatRequireConsiderationActsSuchAsSelfHarm
                "
                setKey="behaviorsThatRequireConsiderationActsSuchAsSelfHarm"
                :options="useDefine.defineObject.NUMBERSELECTION_OPTION_ARRAY"
                @input-emit="handleUpdateValue"
                :is-tap="true"
                class="w-100"
              ></atoms-input-radio-block>

              <atoms-input-textarea
                label="具体的な様子"
                placeholder="具体的な様子"
                :required="false"
                v-model="
                  formData.behaviorsThatRequireConsiderationSpecificSituation
                "
                setKey="behaviorsThatRequireConsiderationSpecificSituation"
                @input-emit="handleUpdateValue"
              ></atoms-input-textarea>

              <atoms-input-textarea
                label="要配慮行動"
                placeholder="要配慮行動"
                :required="false"
                v-model="
                  formData.behaviorsThatRequireConsiderationRequiringSpecialAction
                "
                setKey="behaviorsThatRequireConsiderationRequiringSpecialAction"
                @input-emit="handleUpdateValue"
              ></atoms-input-textarea>
            </div>
          </div>
        </section>
      </div>

      <div class="tab -12" v-if="tabs === 12">
        <section class="form-section u-mb20">
          <atoms-label label="生活上の困難な問題" />
          <p>記入にあたって以下を基準にし、当てはまる番号を選択してください</p>
          <div class=" u-mt5 bold flex">
            <p class="u-mr10">A:すぐに要改善</p>
            <p class="u-mr10">B:改善が必要</p>
            <p class="u-mr10">C:できるなら改善が必要</p>
            <p>D:現状維持</p>
          </div>
          <div class="contents-wrap u-mt0">
            <atoms-sub-label index="3-27" label="生活上の問題" />
            <atoms-input-radio-block
              label="（1）生活費など経済的な問題"
              v-model="formData.lifeProblemsFinancialProblems"
              setKey="lifeProblemsFinancialProblems"
              :options="useDefine.defineObject.ALPHABETSELECTION_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
              class="w-100"
            ></atoms-input-radio-block>

            <atoms-input-radio-block
              label="（2）住まいの問題"
              v-model="formData.lifeProblemsHousingProblems"
              setKey="lifeProblemsHousingProblems"
              :options="useDefine.defineObject.ALPHABETSELECTION_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
              class="w-100"
            ></atoms-input-radio-block>

            <atoms-input-radio-block
              label="（3）日中活動の場の問題"
              v-model="formData.lifeProblemsProblemsWithDaytimeActivities"
              setKey="lifeProblemsProblemsWithDaytimeActivities"
              :options="useDefine.defineObject.ALPHABETSELECTION_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
              class="w-100"
            ></atoms-input-radio-block>

            <atoms-input-radio-block
              label="（4）気軽に相談できる相談相手の問題"
              v-model="formData.lifeProblemsProblemsWithCounselor"
              setKey="lifeProblemsProblemsWithCounselor"
              :options="useDefine.defineObject.ALPHABETSELECTION_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
              class="w-100"
            ></atoms-input-radio-block>

            <atoms-input-radio-block
              label="（5）日常生活について手助けをしてくれる人の問題"
              v-model="formData.lifeProblemsHelpProblem"
              setKey="lifeProblemsHelpProblem"
              :options="useDefine.defineObject.ALPHABETSELECTION_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
              class="w-100"
            ></atoms-input-radio-block>

            <atoms-input-radio-block
              label="（6）家族関係の問題"
              v-model="formData.lifeProblemsFamilyRelationshipIssues"
              setKey="lifeProblemsFamilyRelationshipIssues"
              :options="useDefine.defineObject.ALPHABETSELECTION_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
              class="w-100"
            ></atoms-input-radio-block>

            <atoms-input-textarea
              label="備考"
              placeholder="備考"
              :required="false"
              v-model="formData.lifeProblemsRemarks"
              setKey="lifeProblemsRemarks"
              @input-emit="handleUpdateValue"
            ></atoms-input-textarea>

            <atoms-input-textarea
              label="その他の問題"
              placeholder="その他の問題"
              :required="false"
              v-model="formData.lifeProblemsOtherIssues"
              setKey="lifeProblemsOtherIssues"
              @input-emit="handleUpdateValue"
            ></atoms-input-textarea>
          </div>

          <div class="contents-wrap">
            <atoms-sub-label index="3-28" label="主治医の意見" />
            <atoms-input-textarea
              label="福祉サービスの利用について"
              placeholder="福祉サービスの利用について"
              :required="false"
              v-model="formData.doctorOpinionUseOfWelfareServices"
              setKey="doctorOpinionUseOfWelfareServices"
              @input-emit="handleUpdateValue"
            ></atoms-input-textarea>

            <atoms-input-textarea
              label="禁忌事項等"
              placeholder="禁忌事項等"
              :required="false"
              v-model="formData.doctorOpinionContraindications"
              setKey="doctorOpinionContraindications"
              @input-emit="handleUpdateValue"
            ></atoms-input-textarea>

            <div class="form-content u-mt30 u-mb20">
              <p class="form-content-title">情報聴取先</p>

              <atoms-input-text
                label="機関名"
                type="text"
                placeholder="機関名"
                inputmode="text"
                :required="false"
                v-model="
                  formData.doctorOpinionInformationListeningDestinationInstitutionAttended
                "
                setKey="doctorOpinionInformationListeningDestinationInstitutionAttended"
                @input-emit="handleUpdateValue"
              ></atoms-input-text>

              <atoms-input-text
                label="医師名"
                type="text"
                placeholder="医師名"
                inputmode="text"
                :required="false"
                v-model="
                  formData.doctorOpinionInformationListeningDestinationDoctor
                "
                setKey="doctorOpinionInformationListeningDestinationDoctor"
                @input-emit="handleUpdateValue"
              ></atoms-input-text>

              <atoms-input-select-date
                :date="
                  formData.doctorOpinionInformationListeningDestinationEnteredDate
                "
                label="記入日"
                set-key="doctorOpinionInformationListeningDestinationEnteredDate"
                @input-value="handleInputValue"
              />
            </div>
          </div>
        </section>
      </div>
      <div class="check_button_wrap prev_and_next">
        <div class="prev">
          <atoms-note-button
            v-if="tabs > tabsMin"
            buttonText="前の項目へ"
            @confirm="handlePrevTabs"
          />
        </div>
        <div class="next">
          <atoms-note-button
            v-if="tabs < tabsMax"
            buttonText="次の項目へ"
            @confirm="handleNextTabs"
          />
        </div>
      </div>
    </div>
    <div class="form-tabs" v-if="nextPageTitle">
      <atoms-note-button
        :buttonText="`${nextPageTitle}へ`"
        @confirm="handleUpdateFormTab"
      />
    </div>
  </div>
</template>

<script>
import { defineObject } from '@/lib/define/use-define'
import formUtils from '@/lib/formUtils/form-utils'
import OrganismsAnchorLink from '@/components/organisms/basicSurvey/OrganismsAnchorLink.vue'
export default {
  components: {
    OrganismsAnchorLink,
  },
  data() {
    return {
      tabsMin: 0,
      tabsMax: 12,
      tabs: 0,
      // formの選択肢
      useDefine: { defineObject: defineObject },
      // emit対象のformデータ
      formData: {
        createdDate: '',
        lastName: '',
        firstName: '',
        writer: '',
        motionTheFloorRollingOver: '',
        motionTheFloorGetUp: '',
        motionTheFloorSittingPositionHeld: '',
        motionTheFloorStandingHolding: '',
        motionTheFloorTransfer: '',
        motionTheFloorPlaceAuxiliaryEquipmentSituation: '',
        motionTheFloorElectricBed: '',
        motionTheFloorUseOfAirMat: '',
        motionMovementIndoor: '',
        motionMovementOutdoors: '',
        motionMovementUseOfProsthetics: '',
        motionBathingTubAndOut: '',
        motionBathingWashing: '',
        motionBathingShampoo: '',
        motionBathingConsiderations: '',
        motionBathingMethod: '',
        motionBathingHeight: '',
        motionBathingWeight: '',
        motionExcretionUrination: '',
        motionExcretionUrinationViews: '',
        motionExcretionUrinationUrinate: '',
        motionExcretionUrinationTransmission: '',
        motionExcretionDefecation: '',
        motionExcretionDefecationViews: '',
        motionExcretionDefecationBowelMovement: '',
        motionExcretionDefecationTransmission: '',
        motionExcretionDefecationIncontinence: '',
        motionExcretionDefecationBowelMove: '',
        motionExcretionIndirectSupport: '',
        motionExcretionMethod: '',
        motionMealDietaryIntake: '',
        motionMealDrinkingWater: '',
        motionMealSwallowing: '',
        motionMealMealForm: '',
        motionMealUseOfSelfHelpTool: '',
        motionMealUseOrganicSelfHelpTool: '',
        motionMealNutritionalStatus: '',
        motionMealDiet: '',
        motionMealSpecialDietMenus: '',
        motionMealMealTimes: '',
        motionMealAppetite: '',
        motionCleanlinessOralCleanliness: '',
        motionCleanlinessCleansing: '',
        motionCleanlinessHairdressing: '',
        motionCleanlinessNailClippers: '',
        motionRemovableJacket: '',
        motionRemovableTrousers: '',
        motionIAdlWashing: '',
        motionIAdlCleanUp: '',
        motionIAdlOrganizeAndTidy: '',
        motionIAdlShopping: '',
        motionIAdlCooking: '',
        motionIAdlMoneyManagement: '',
        motionIAdlUseOfTelephone: '',
        motionCommunicationSkillsEyesight: '',
        motionCommunicationSkillsVisuallyImpaired: '',
        motionCommunicationSkillsUseOfWhiteCane: '',
        motionCommunicationSkillsHearing: '',
        motionCommunicationSkillsHearingImpairment: '',
        motionCommunicationSkillsHearingAid: '',
        motionCommunicationSkillsSignLanguage: '',
        motionCommunicationSkillsTransmissionOfIntention: '',
        motionCommunicationSkillsLanguageDisorders: '',
        motionCommunicationSkillsCommunicationEquipment: '',
        motionCommunicationSkillsLevelOfUnderstanding: '',
        motionCommunicationSkillsSpeak: '',
        motionCommunicationSkillsWrite: '',
        motionCommunicationSkillsRead: '',
        motionCommunicationSkillsDementiaSymptoms: '',
        motionCommunicationSkillsPsychiatricSymptoms: '',
        motionCommunicationSkillsIntellectualDisability: '',
        motionBehaviorRequiringConsideration: '',
        motionBehaviorRequiringConsiderationHaveIntellectualDisability: '',
        // b
        affairsProcessingMeal: '',
        affairsProcessingExcretion: '',
        affairsProcessingClothesDetachable: '',
        affairsProcessingBathing: '',
        affairsProcessingGrooming: '',
        affairsProcessingSettlementOfPhysiological: '',
        affairsProcessingMedicationHealthManagement: '',
        affairsProcessingSpecificSituation: '',
        affairsProcessingOtherAssistance: '',
        communicationManifestationOfIntention: '',
        communicationUnderstandingOfCommunication: '',
        communicationSpecificSituation: '',
        communicationOtherAssistance: '',
        everydayLifeWashing: '',
        everydayLifeCleanUp: '',
        everydayLifeOrganizeAndTidy: '',
        everydayLifeShopping: '',
        everydayLifeCooking: '',
        everydayLifeSpecificSituation: '',
        socialLifeOutdoorMovement: '',
        socialLifeInterpersonalRelations: '',
        socialLifeMoneyManagement: '',
        socialLifeLetter: '',
        socialLifeGroup: '',
        socialLifeTime: '',
        socialLifeSpecificSituation: '',
        socialLifeConsiderationBehaviorStrongCommitment: '',
        socialLifeConsiderationBehaviorHyperactivity: '',
        socialLifeConsiderationBehaviorPanic: '',
        socialLifeConsiderationBehaviorSleepingDisorder: '',
        socialLifeConsiderationBehaviorMaladaptativeBehavior: '',
        socialLifeConsiderationBehaviorSelfHarmOtherHarm: '',
        socialLifeConsiderationBehaviorSpecificSituation: '',
        // c
        livingAbilityPersonalBelongingsPersonalHygiene: '',
        livingAbilityPersonalBelongingsRoomArrangement: '',
        livingAbilityPersonalBelongingsMoneyManagement: '',
        livingAbilityPersonalBelongingsWashing: '',
        livingAbilityPersonalBelongingsShopping: '',
        livingAbilityPersonalBelongingsMeals: '',
        livingAbilityPersonalBelongingsMakeMeal: '',
        livingAbilityPersonalBelongingsSpecificSituation: '',
        livingAbilitySafetyManagementCrisisManagement: '',
        livingAbilitySafetyManagementDisposeOfFire: '',
        livingAbilitySafetyManagementSpecificSituation: '',
        livingAbilityHealthManagementRegularVisits: '',
        livingAbilityHealthManagementMedicationManagement: '',
        livingAbilityHealthManagementPhysicalHealthManagement: '',
        livingAbilityHealthManagementSpecificSituation: '',
        livingAbilitySocialResourcesUseOfTransportation: '',
        livingAbilitySocialResourcesUseOfFinancialInstitutions: '',
        livingAbilitySocialResourcesUseOfTelephone: '',
        livingAbilitySocialResourcesSpecificSituation: '',
        livingAbilityInterpersonalRelationsMinimalRelationship: '',
        livingAbilityInterpersonalRelationsCooperation: '',
        livingAbilityInterpersonalRelationsSpontaneous: '',
        livingAbilityInterpersonalRelationsHangingOutWithFriends: '',
        livingAbilityInterpersonalRelationsSpecificSituation: '',
        livingAbilitySocialRoleUtilizationOfTimeOwnSocialRole: '',
        livingAbilitySocialRoleUtilizationOfTimeFreeTime: '',
        livingAbilitySocialRoleUtilizationOfTimeLifeRhythm: '',
        livingAbilitySocialRoleUtilizationOfTimeSpecificSituation: '',
        emergencyResponseConsultationOfConcerns: '',
        emergencyResponseDeal: '',
        emergencyResponseSpecificSituation: '',
        behaviorsThatRequireConsiderationMannersInPublic: '',
        behaviorsThatRequireConsiderationActsSuchAsSelfHarm: '',
        behaviorsThatRequireConsiderationSpecificSituation: '',
        behaviorsThatRequireConsiderationRequiringSpecialAction: '',
        lifeProblemsFinancialProblems: '',
        lifeProblemsHousingProblems: '',
        lifeProblemsProblemsWithDaytimeActivities: '',
        lifeProblemsProblemsWithCounselor: '',
        lifeProblemsHelpProblem: '',
        lifeProblemsFamilyRelationshipIssues: '',
        lifeProblemsRemarks: '',
        lifeProblemsOtherIssues: '',
        doctorOpinionUseOfWelfareServices: '',
        doctorOpinionContraindications: '',
        doctorOpinionInformationListeningDestinationInstitutionAttended: '',
        doctorOpinionInformationListeningDestinationDoctor: '',
        doctorOpinionInformationListeningDestinationEnteredDate: '',
      },
    }
  },
  props: {
    propsFormData: {
      type: Object,
      required: true,
    },
    setObjectKey: {
      type: String,
      required: true,
    },
    pageTitle: {
      type: String,
      required: true,
    },
    nextPageTitle: {
      type: String,
      required: false,
    },
    childName: {
      type: String,
      required: false,
    },
    schoolYear: {
      type: String,
      required: false,
    },
  },
  methods: {
    handleUpdateValue(setKey, setVal) {
      this.formData[setKey] = setVal
      this.$emit('input-emit', this.setObjectKey, setKey, setVal)
    },
    handleInputValue(value, key) {
      const date = `${value.getFullYear()}-${value.getMonth() +
        1}-${value.getDate()}`
      this.formData[key] = date
      this.$emit('input-emit', this.setObjectKey, key, date)
    },
    handlePrevTabs() {
      this.handleSmoothScroll()
      this.tabs--
    },
    handleNextTabs() {
      this.handleSmoothScroll()
      this.tabs++
    },
    handleSmoothScroll() {
      this.$smoothScroll({
        scrollTo: document.getElementById('app'), // scrollTo is also allowed to be number
      })
    },
    handleUpdateFormTab() {
      this.$emit('click-tab-switch', this.setObjectKey)
    },
    goToPage(tab) {
      this.tabs = tab
    },
  },
  mounted() {
    Object.keys(this.formData).forEach(key => {
      if (this.propsFormData[key]) {
        this.formData[key] = this.propsFormData[key]
      }

      this.handleUpdateValue(key, this.formData[key])
    })

    if (!this.formData.createdDate) {
      this.formData.createdDate = formUtils.handleSetJapaneseCalendar(
        new Date(),
        '',
        'none'
      )
      this.handleUpdateValue('createdDate', this.formData.createdDate)
    }
  },
}
</script>
<style lang="scss" scoped>
.form-tabs {
  margin: 0 auto;
  max-width: 460px;
  button {
    width: 100%;
  }
}
</style>
